import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

// helpers/services in your project
import { authHeader } from "_helpers";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Label, Input, FormGroup } from "reactstrap";
import Datetime from "react-datetime";

// core components (match your project structure)
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSUser from "components/Forms/TSUser";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody } from "reactstrap";

import {
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper, TableSortLabel, TableFooter, TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@material-ui/core';

import "react-datetime/css/react-datetime.css";
import "./custom-style.css";
import zIndex from "@material-ui/core/styles/zIndex";

// -------------------- Styles --------------------
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: 0,
    fontSize: "14px",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: 0,
    minHeight: "auto",
    fontWeight: 300,
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitleCustom: {
    background: "linear-gradient(to right, #2193b0, #6dd5ed)",
    margin: "-20px 15px 15px 15px",
  },
};
const useStyles = makeStyles(styles);

// -------------------- Component --------------------
const ESignList = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);

  const { location } = props;
  const _teamGroupKeyFromRoute = props.match?.params?.TeamGroupKey ?? null; // e.g. /team-group/request/:TeamGroupKey

  const moment = require("moment");
  require("moment/locale/th");

  const [docDT, setDocDT] = useState(moment().format("YYYY-MM-DD")); // ค่าเริ่มต้น วันนี้
    const [keyword, setKeyword] = useState("");
    const [keywordInput, setKeywordInput] = useState(""); // ไว้ผูกกับช่อง TSText
  const [serviceUnitKey, setServiceUnitKey] = useState(0); // 0 = ไม่ filter
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // ------- Form State -------
  const [TeamGroupKey, setTeamGroupKey] = useState(null);

  const [FilterServiceUnitKey, setFilterServiceUnitKey] = useState('');

  const [editKey, setEditKey] = useState(null);
  const [Code, setCode] = useState("");
  const [Name, setName] = useState(""); // ชื่อกรรมการ/ชื่อกลุ่ม

  // Lookups
  const [ArrServiceUnit, setArrServiceUnit] = useState([]);
  const [ArrTeamGroupRole, setArrTeamGroupRole] = useState([]);

  // Members
  const [Members, setMembers] = useState([]); // [{ userName, teamGroupUserKey?, teamGroupRoleKey? }]

  // UI
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [isOpen, setIsOpen] = useState(false);
  const [isShowList, setIsShowList] = useState(true);

  const [dateFocus, setDateFocus] = useState(false);

  //Table
    const [dataList, setDataList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [orderDirection, setOrderDirection] = useState('desc');
    const [orderBy, setOrderBy] = useState('code'); // default column to sort
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await axios.get("/api/v1/reportview/esignlist", {
                    params: {
                        docDT: docDT || undefined,                 // ถ้าว่างให้เป็น undefined → ไม่ส่ง
                        keyword: keyword || undefined,             // ถ้าว่างไม่ส่ง
                        serviceUnitKey: serviceUnitKey || undefined // 0 หรือ null → ไม่ส่ง
                    },
                });

                setDataList(response.data?.data || []);


                var _data = response.data?.data;

                if (_data && _data.length > 0) {
                    const unique = [
                        ...new Map(
                            _data.map(item => [item.serviceUnitKey, {
                                ServiceUnitKey: item.serviceUnitKey,
                                ServiceUnitName: item.serviceUnitName,
                                value: item.serviceUnitKey,
                                label: item.serviceUnitName,
                            }])
                        ).values()
                    ];
                    setArrServiceUnit(unique);
                    console.log(unique)
                }




            } catch (err) {
                console.error(err);
                setError(err.message || "Error");
            } finally {
                setLoading(false);
            }
        };

        // ป้องกันไม่ให้ยิงตอน docDT ว่างเลย (แล้วแต่จะใช้)
        if (!docDT || docDT.trim() === "") return;

        fetchData();
    }, [docDT, keyword, serviceUnitKey]); // 👈 deps ที่ต้องการให้ trigger


  const handleClear = async (evt) => {
    //evt.preventDefault();
    // ไม่มี use case ยกเลิก TeamGroup แบบ request เดิม ถ้าต้องการให้ archive/disable แจ้งผมได้
    setIsShowList(true);
    setTeamGroupKey(0);
    setCode("");
    setName("");
    setEditKey(null);
    setSelectedData([]);
    setMembers([]);
    setModalCancel(false);
  };

  const GotoEdit = (evt) => {
    evt.preventDefault();
    setModal2(false);
    if (TeamGroupKey) {
      history.push({ pathname: "/team/group/" + TeamGroupKey });
    }
  };

  const handleAdd = () => {
        //clearForm();
        //setModalOpen(true);
        setIsShowList(false);
  };

  const handleEdit = (index, _data) => {
        //setEditIndex(index);
        //setIsEditing(true);
        //setSelectedData(_data);
        //setModalOpen(true);
        setIsShowList(false);
        setEditKey(_data.teamGroupKey);
    };

  const handleMembersChange = (users) => {
    // Normalize selection into { userName, firstName, lastName }
    // and set default role = 6 if not already assigned.
    // Note: TSUser items may contain either { userName, firstName, lastName }
    // or { value, label } — we try to capture names when available.
    const norm = users.map((u) => ({
      userName: u.userName || u.value || u,
      firstName: u.firstName || u.givenName || "",
      lastName: u.lastName || u.familyName || "",
    }));

    const byName = new Map(Members.map((m) => [m.userName, m]));

    const merged = norm.map((n) => {
    const prev = byName.get(n.userName) || {};
    const role = (prev.teamGroupRoleKey ?? null) != null ? prev.teamGroupRoleKey : 5; //default 5 = กรรมการ
      return {
        ...prev,
        userName: n.userName,
        firstName: n.firstName || prev.firstName || "",
        lastName: n.lastName || prev.lastName || "",
        teamGroupRoleKey: role,
      };
    });

    setMembers(merged);
  };

  const handleRequestSort = (property) => {
        const isAsc = orderBy === property && orderDirection === 'asc';
        setOrderDirection(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
  };

  const sortedData = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === 'asc') {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
  };

  const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


  const handleRoleChange = (userName, roleOption) => {
    setMembers((prev) =>
      prev.map((m) => (m.userName === userName ? { ...m, teamGroupRoleKey: roleOption?.value ?? null } : m))
    );
  };

  // -------------------- Render --------------------
  return (
    <div>
      <Grid>

        <Col xs={12} sm={12} md={12} style={{ display: isShowList ? 'block': 'none' }}>
          <Card>
                <CardHeader color="primary">
                    <h4 className={classes.cardTitleWhite}>รายการหัตถการ</h4>
                </CardHeader>
                <CardBody>
                    <div>
                        <Grid>
                            <Col xs={12} sm={4} md={4}>
                                      <Label>วันที่รับบริการ</Label>
                                      <FormGroup
                                          style={{ padding: '0 0px', marginBottom: '10px' }}
                                          className={
                                              "input-lg" + (dateFocus ? " input-group-focus" : "")
                                          }
                                      >
                                          <i className="far fa-calendar-check fa-2x" style={{
                                              position: 'absolute',
                                              left: '30px',
                                              zIndex: 1,

                                          }}
                                          ></i>
                                          <Datetime
                                              value={moment(docDT).isValid() ? moment(docDT) : null}
                                              renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                              //isValidDate={isDateValid}
                                              //renderDay={renderDay}
                                              //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                              //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                              //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                              inputProps={{
                                                  name: "docDT", placeholder: "วันที่รับบริการ", readOnly: 'readonly'
                                                  , style: {
                                                      fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                  }
                                              }}
                                              closeOnSelect={true}
                                              closeOnTab={true}
                                              dateFormat="D MMMM BBBB" timeFormat={false}
                                              //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                              //timeFormat={false}
                                              onFocus={() => setDateFocus(true)}
                                              onBlur={() => setDateFocus(false)}
                                              onChange={e => setDocDT(e.format('YYYY-MM-DD'))}


                                          />


                                      </FormGroup>
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                      <TSText icon="far fa-edit" label="คำค้นหา" value={keywordInput} placeholder={"ค้นหา 3 ตัวอักษรขึ้นไป"}
                                          //onChange={e => setKeyword(e.target.value)}
                                          onChange={e => {
                                              const v = e.target.value;
                                              setKeywordInput(v); // ให้กล่องแสดงค่าตามที่พิมพ์
                                              // ✅ อัปเดต keyword เฉพาะตอนว่าง หรือยาวเกิน 3 ตัว
                                              if (v === "" || v.length >= 3) {
                                                  setKeyword(v);
                                              }
                                          }}
                                      />
                            </Col>
                            <Col xs={12} sm={4} md={4}>
                                <TSSelect2 isClearable={true} label="หน่วยบริการ" options={ArrServiceUnit} value={serviceUnitKey} onChange={e => setServiceUnitKey(e != null ? e.value : '') } />
                            </Col>
                        </Grid>

                        
                        <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'hn'}
                                                direction={orderBy === 'hn' ? orderDirection : 'asc'}
                                                onClick={() => handleRequestSort('hn')}
                                            >
                                                HN
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={orderBy === 'fullName'}
                                                      direction={orderBy === 'fullName' ? orderDirection : 'asc'}
                                                      onClick={() => handleRequestSort('fullName')}
                                            >
                                                ชื่อ
                                            </TableSortLabel>
                                              </TableCell>

                                        <TableCell>หัตถการ</TableCell>

                                        <TableCell style={{ display: (serviceUnitKey == 0 ? 'table-cell' : 'none') }}>
                                            <TableSortLabel
                                                active={orderBy === 'serviceUnitName'}
                                                      direction={orderBy === 'serviceUnitName' ? orderDirection : 'asc'}
                                                      onClick={() => handleRequestSort('serviceUnitName')}
                                            >
                                                หน่วยบริการ
                                            </TableSortLabel>
                                        </TableCell>                                                     
                                    </TableRow>
                                </TableHead>
                                      <TableBody>
                                          {sortedData()
                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                              .map((data, index) => {
                                                  const rowIndex = page * rowsPerPage + index; // ให้ต่อเนื่องข้ามหน้า

                                                  return (
                                                      <TableRow
                                                          key={index}
                                                          className={classes.tableRow}
                                                          style={{
                                                              backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#ffffff',
                                                          }}
                                                      >
                                                          <TableCell>
                                                              <Label
                                                                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                  onClick={() => handleEdit(index, data)}
                                                              >
                                                                  {data.hn}
                                                              </Label>
                                                          </TableCell>
                                                          <TableCell>
                                                              <Label
                                                                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                                  onClick={() => handleEdit(index, data)}
                                                              >
                                                                  {data.fullName}
                                                              </Label>
                                                          </TableCell>
                                                          <TableCell
                                                              style={{ paddingLeft: '10px' }}
                                                              className={classes.tableCell}
                                                          >
                                                              {data.itemName}
                                                          </TableCell>
                                                          <TableCell
                                                              style={{
                                                                  paddingLeft: '10px',
                                                                  display: serviceUnitKey == 0 ? '' : 'none',
                                                              }}
                                                              className={classes.tableCell}
                                                          >
                                                              {data.serviceUnitName}
                                                          </TableCell>
                                                      </TableRow>
                                                  );
                                              })}
                                      </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[100]}
                                            count={dataList.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
                </CardBody>
                <CardFooter>

                </CardFooter>
          </Card>
      </Col>

      </Grid>

      {/* Modals */}
      <CardFooter>
        <Collapse isOpen={isOpen}></Collapse>

        {/* Confirm */}
        <Modal toggle={() => setModal(false)} isOpen={modal}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={icon} style={{ color: "blue", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>
              {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg" ? "ยืนยันการบันทึกข้อมูล" : "กำลังตรวจสอบข้อมูล"}
            </p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="success" type="button" /*onClick={}*/ disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยืนยัน</h4>
            </Button>
            <Button color="danger" type="button" onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}>
              <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยกเลิก</h4>
            </Button>
          </div>
        </Modal>

        {/* Cancel (placeholder) */}
        <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={icon} style={{ color: "red", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>
              {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg" ? "ปิดหน้าฟอร์มนี้หรือไม่?" : "กำลังตรวจสอบข้อมูล"}
            </p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="success" type="button" onClick={(e)=>{ handleClear(); }} disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยืนยัน</h4>
            </Button>
            <Button color="danger" type="button" onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}>
              <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ปฏิเสธ</h4>
            </Button>
          </div>
        </Modal>

        {/* Success */}
        <Modal toggle={GotoEdit} isOpen={modal2}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={"fas fa-check"} style={{ color: "green", fontSize: "4em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>บันทึกข้อมูลสำเร็จ</p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="info" type="button" onClick={GotoEdit}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ตกลง</h4>
            </Button>
          </div>
        </Modal>

        {/* Error */}
        <Modal toggle={() => setModalError(false)} isOpen={modalError}>
          <div className="modal-header justify-content-center">
            <div>
              <i className="fa fa-times" style={{ color: "red", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p>ไม่สามารถบันทึกข้อมูลได้</p>
            <div>{errMsg}</div>
          </ModalBody>
          <div className="modal-footer justify-content-center">
            <Button color="primary" type="button" onClick={() => setModalError(false)}>
              <h4>ตกลง</h4>
            </Button>
          </div>
        </Modal>
      </CardFooter>
    </div>
  );
};

export default ESignList;
